import React from 'react'
import { connect } from 'react-redux'
import { Button, Card, Table, Tag, message } from 'antd'
import PageHeader from '@/components/PageHeader'
import Permission from '@/components/PermissionA5'
import { Search, SelectC } from '@/i2antdV5'
import { formatDateTimeStr, renderMoney, renderMoneyStr, renderTextStr } from '@/utils/renderUtils'
import { fetchJStoreList } from '@/redux/components/getJStoreListSlice'
import { fetchTuinaPurchaseOrderList } from '@/redux/tuina/purchaseOrderListSlice'
import { fetchTuinaMemberList } from '@/redux/tuina/memberListSlice'
import { TUINA_PAY_METHOD_OPTIONS, TUINA_PAY_STATUS_OPTIONS } from '@/views/tuina/options'
import PurchasePayModal from '@/views/tuina/projects/share/PurchasePayModal'
import PurchaseOrderModal from '@/views/tuina/projects/share/PurchaseOrderModal'
import './Page.less'

const breadcrumbList = [
  { breadcrumbName: '按摩' },
  { breadcrumbName: '订单列表' }
]

/** 列表默认查询（仅页面侧使用，不写入 Redux initialState） */
const DEFAULT_TUINA_PURCHASE_ORDER_LIST_QUERY = {
  pageNumber: 1,
  pageSize: 20
}

const mergeTuinaPurchaseOrderListQuery = (reduxQuery) =>
  reduxQuery && Object.keys(reduxQuery).length > 0 ? reduxQuery : DEFAULT_TUINA_PURCHASE_ORDER_LIST_QUERY

class TuinaOrdersPage extends React.Component {
  didInitList = false

  componentDidMount () {
    this.props.fetchJStoreList({ query: {}, dataType: 'optionTuina' })
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载门店列表失败'))
  }

  componentDidUpdate (prevProps) {
    if (this.didInitList) return
    if (this.props.getJStoreList.fetching) return
    if (!prevProps.getJStoreList.fetching) return
    this.didInitList = true
    const options = this.props.getJStoreList.data
    const first = Array.isArray(options) && options[0]
    const query = { ...DEFAULT_TUINA_PURCHASE_ORDER_LIST_QUERY }
    if (first && first.id != null && first.id !== '') query.storeId = first.id
    this.fetchList(query)
  }

  fetchMembers = (formatQuery = {}) => {
    const storeId = formatQuery.storeId
    const memberQuery = { pageNumber: 1, pageSize: 200 }
    if (storeId != null && storeId !== '') memberQuery.storeId = storeId
    this.props
      .fetchTuinaMemberList({ query: memberQuery, dataType: 'option' })
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载会员失败'))
  }

  fetchList = (formatQuery) => {
    if (this.didInitList) {
      const prevStoreId = this.props.purchaseOrderList.query.storeId
      if (String(prevStoreId ?? '') !== String(formatQuery.storeId ?? '')) {
        this.fetchMembers(formatQuery)
      }
    }
    this.props
      .fetchTuinaPurchaseOrderList({ query: formatQuery })
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载订单失败'))
  }

  handleTableChange = (pagination) => {
    const query = mergeTuinaPurchaseOrderListQuery(this.props.purchaseOrderList.query)
    this.fetchList({
      ...query,
      pageNumber: pagination.current,
      pageSize: pagination.pageSize
    })
  }

  refreshList = () => {
    this.fetchList(mergeTuinaPurchaseOrderListQuery(this.props.purchaseOrderList.query))
  }

  handleModalSuccess = () => {
    this.refreshList()
  }

  payMethodText = (v) => {
    const row = TUINA_PAY_METHOD_OPTIONS.find((item) => item.id === v)
    return (row && row.value) || v
  }

  getColumns = () => [
    {
      title: '订单',
      dataIndex: 'orderNo',
      width: 200,
      render: (v, record) => (
        <div className="tuina-order-cell">
          <span className="tuina-order-no">{renderTextStr(v)}</span>
          <span className="tuina-order-meta">{renderTextStr(formatDateTimeStr(record.createdAt))}</span>
          {record.memberName == null || record.memberName === ''
            ? null
            : <span className="tuina-order-meta">会员 {record.memberName}</span>}
        </div>
      )
    },
    {
      title: '下单人',
      dataIndex: 'operatorName',
      width: 120,
      render: (v) => renderTextStr(v)
    },
    {
      title: '项目',
      dataIndex: 'projectName',
      render: (v, record) => {
        const n = Number(record.durationMinutes)
        return (
          <div className="tuina-order-cell">
            <span>{renderTextStr(v)}</span>
            {record.durationMinutes == null || record.durationMinutes === '' || !Number.isFinite(n)
              ? null
              : <span className="tuina-order-meta">{n}分钟</span>}
            {record.remark
              ? <span className="tuina-order-meta">{record.remark}</span>
              : null}
          </div>
        )
      }
    },
    {
      title: '金额',
      dataIndex: 'totalAmount',
      width: 140,
      align: 'right',
      render: (v, record) => {
        const n = Number(record.quantity)
        return (
          <div className="tuina-order-cell tuina-order-cell-right">
            <span className="tuina-order-price">{renderMoney(v)}</span>
            {record.quantity == null || record.quantity === '' || !Number.isFinite(n)
              ? null
              : <span className="tuina-order-meta">{renderMoneyStr(record.unitPrice)} × {n}</span>}
          </div>
        )
      }
    },
    {
      title: '支付',
      dataIndex: 'payStatus',
      width: 220,
      render: (v, record) => {
        const row = TUINA_PAY_STATUS_OPTIONS.find((item) => item.id === v)
        const text = (row && row.value) || v
        return (
          <div className="tuina-order-cell">
            {text ? <Tag color={(row && row.color) || 'default'}>{text}</Tag> : renderTextStr(text)}
            {record.payMethod
              ? <span className="tuina-order-meta">{this.payMethodText(record.payMethod)}</span>
              : null}
            {record.payNo
              ? <span className="tuina-order-meta">{record.payNo}</span>
              : null}
            {record.payTime
              ? <span className="tuina-order-meta">{formatDateTimeStr(record.payTime)}</span>
              : null}
          </div>
        )
      }
    },
    {
      title: '操作',
      key: 'actions',
      width: 120,
      fixed: 'right',
      render: (_, record) => {
        if (record.payStatus !== 'unpaid') return null
        return (
          <Permission rootPath="tuinaPage">
            <div pathitem={['orders']} checkarray={['buttonCodes']} className="tuina-order-actions">
              <PurchasePayModal orderNo={record.orderNo} payMethod={record.payMethod} onSuccess={this.handleModalSuccess}>
                <Button type="link" aria-label={`支付确认 ${record.orderNo}`}>支付确认</Button>
              </PurchasePayModal>
            </div>
          </Permission>
        )
      }
    }
  ]

  render () {
    const { purchaseOrderList, getJStoreList, memberList } = this.props
    const { fetching, query: reduxQuery, data } = purchaseOrderList
    const query = mergeTuinaPurchaseOrderListQuery(reduxQuery)
    const list = Array.isArray(data.list) ? data.list : []
    const totalRow = data.totalRow || 0
    const jStoreOptions = getJStoreList.data
    const memberOptions = Array.isArray(memberList.data) ? memberList.data : []

    return (
      <div>
        <PageHeader title="订单列表" breadcrumbList={breadcrumbList} />
        <div className="i2-container">
          <Card className="i2-card-page">
            <section className="i2-app-toolbar tuina-order-toolbar">
              <div className="toolbar-filters">
                <SelectC
                  label="门店"
                  query={query}
                  searchKey="storeId"
                  options={jStoreOptions}
                  action={this.fetchList}
                  placeholder="全部"
                  clearKey="memberId"
                  modalProps={{ allowClear: true }}
                />
                <SelectC
                  label="会员"
                  query={query}
                  searchKey="memberId"
                  options={memberOptions}
                  action={this.fetchList}
                  placeholder="全部"
                  modalProps={{ allowClear: true }}
                />
                <Search
                  label="关键字"
                  query={query}
                  searchKey="keyword"
                  action={this.fetchList}
                  modalProps={{ allowClear: true, placeholder: '关键词' }}
                />
                <SelectC
                  label="支付状态"
                  query={query}
                  searchKey="payStatus"
                  options={TUINA_PAY_STATUS_OPTIONS}
                  action={this.fetchList}
                  placeholder="全部"
                  modalProps={{ allowClear: true }}
                />
              </div>
              <div className="toolbar-btns">
                <Permission rootPath="tuinaPage">
                  <span pathitem={['orders']} checkarray={['buttonCodes']}>
                    <PurchaseOrderModal
                      storeId={query.storeId}
                      onSuccess={this.handleModalSuccess}
                    >
                      <Button type="primary" size="large">下单</Button>
                    </PurchaseOrderModal>
                  </span>
                </Permission>
              </div>
            </section>
            <Table
              className="tuina-order-table"
              rowKey={(r) => String(r.id)}
              columns={this.getColumns()}
              dataSource={list}
              loading={fetching}
              scroll={{ x: 1080 }}
              onChange={this.handleTableChange}
              pagination={{
                current: query.pageNumber,
                pageSize: query.pageSize,
                total: totalRow,
                showSizeChanger: true,
                showTotal: (t) => `共 ${t} 条`,
                pageSizeOptions: ['10', '20', '50', '100']
              }}
            />
          </Card>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  purchaseOrderList: state.tuina.purchaseOrderList,
  getJStoreList: state.components.getJStoreList,
  memberList: state.tuina.memberList
})

const mapDispatchToProps = {
  fetchTuinaPurchaseOrderList,
  fetchJStoreList,
  fetchTuinaMemberList
}

export default connect(mapStateToProps, mapDispatchToProps)(TuinaOrdersPage)
